var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32235 3.57142C7.32235 2.97969 6.84266 2.5 6.25093 2.5C5.6592 2.5 5.17951 2.97969 5.17951 3.57142V4.64284H4.10809C3.22049 4.64284 2.50096 5.36238 2.50096 6.24997V7.8571H17.5009V6.24997C17.5009 5.36238 16.7813 4.64284 15.8937 4.64284H14.8223V3.57142C14.8223 2.97969 14.3426 2.5 13.7509 2.5C13.1591 2.5 12.6795 2.97969 12.6795 3.57142V4.64284H7.32235V3.57142ZM17.5004 9.19649H2.50049V15.8929C2.50049 16.7805 3.22003 17.5 4.10762 17.5H15.8933C16.7808 17.5 17.5004 16.7805 17.5004 15.8929V9.19649Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.24f7c874b68640ab882074f0a3884db0.svg";
export { ForwardRef as ReactComponent };